import { apiClient } from '@/services/api/client';

import type { OrganizationsResponse, LocationCollectionResponse, OrganizationTier } from '../types';

export interface FetchOrganizationsParams {
  page?: number;
  page_size?: number;
  search?: string;
  tier?: OrganizationTier;
}

/**
 * Core API Service
 * Centralizes all core module API calls
 */
export const coreApi = {
  async fetchOrganizations(params: FetchOrganizationsParams = {}): Promise<OrganizationsResponse> {
    return apiClient.get<OrganizationsResponse>('/api/organisation/', { params });
  },

  async setActiveOrganization(orgId: number): Promise<void> {
    return apiClient.post(`/api/organisation/${orgId}/set-active`, {});
  },

  async fetchLocationCollections(
    url = '/api/location-collection/'
  ): Promise<LocationCollectionResponse> {
    return apiClient.get<LocationCollectionResponse>(url);
  },
};
